import React, { useMemo } from "react";
import { FormControl, MenuItem, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { store } from "../store";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function SelectResidence() {
  const residences = useSelector((state) => state.residences);
  const selectedResidence = useSelector(
    (state) => state.selectedResidence
  );
  const selectedEstablishment = useSelector(
    (state) => state.selectedEstablishment
  );

  const { t } = useTranslation("common");

  // Filter residences by selected establishment
  const filteredResidences = useMemo(() => {
    if (!selectedEstablishment || selectedEstablishment === "0") {
      return residences; // Show all if no establishment selected
    }
    return residences.filter(residence => 
      residence.establishment_id === parseInt(selectedEstablishment)
    );
  }, [residences, selectedEstablishment]);

  const navigate = useNavigate();

  const handleChange = (event) => {
    store.dispatch({
      type: "selectedResidence/update",
      payload: event.target.value,
    });
    localStorage.setItem("selectedResidence", event.target.value);
    
    // Navigate to selected residence
    if (event.target.value !== "0") {
      navigate("/view/" + event.target.value);
    }
  };

  return (
    <FormControl fullWidth>
      <TextField
        select
        label={t("common.residence") || "Résidence"}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#26A69A",
            },
            "&:hover fieldset": {
              borderColor: "#26A69A",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#26A69A",
            }
          },
          "& .MuiInputLabel-root": {
            color: "#26A69A",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#26A69A",
          }
        }}
        onChange={handleChange}
        value={selectedResidence}
      >
        <MenuItem 
          key="0" 
          value="0"
          sx={{
            "&.Mui-selected": {
              backgroundColor: "#26A69A",
              color: "white",
              "&:hover": {
                backgroundColor: "#00897B",
              }
            },
            "&:hover": {
              backgroundColor: "rgba(38, 166, 154, 0.1)",
            }
          }}
        >
          {t("common.all")}
        </MenuItem>
        {filteredResidences.map((option) => (
          <MenuItem 
            key={option.id} 
            value={option.id}
            sx={{
              "&.Mui-selected": {
                backgroundColor: "#26A69A",
                color: "white",
                "&:hover": {
                  backgroundColor: "#00897B",
                }
              },
              "&:hover": {
                backgroundColor: "rgba(38, 166, 154, 0.1)",
              }
            }}
          >
            {option.name}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
}
